import {vnTemplate} from "./vnTemplate";

declare var ko: any;

export class filterSingle_multiLevel_selector_template extends vnTemplate{

    protected getTemplateHtml(): string {

        return `

        <div class="w-single-multi-level dropdown" data-bind="css: { 'is-visible' : isVisible }, event: { click: onToggleOpen }">

                <button class="dropdown-toggle" type="button">
                    <label class="form-label" for="" data-bind="text: label"></label>

                    <!-- ko if: hasLogo() && getSelectedOptionLogo() && isCssLogo() -->
                        <label class="bsa-label full-icon" data-bind="css: getSelectedOptionLogo()"></label>
                    <!-- /ko -->

                    <!-- ko if: hasLogo() && getSelectedOptionLogo() && !isCssLogo() -->
                        <img data-bind="attr: {src: getSelectedOptionLogo()}" alt="dropdown">
                    <!-- /ko -->

                    <!-- ko if: hasLogo() && !getSelectedOptionLogo() && isDefaultLogoDefined() -->
                        <img data-bind="attr: {src: defaultLogo()}" alt="dropdown">
                    <!-- /ko -->

                    <span data-bind="text: selectedOptionText"></span>
                </button>

                <ul class="bsa-list-first dropdown-list">

                    <!-- ko foreach: groups -->

                        <li>
                            <label class="bsa-label full-icon">

                                <!-- ko if: !$data.cssClasses && !$data.iconUrl && $parent.isDefaultLogoDefined() -->
                                    <img data-bind="attr: {src: $parent.defaultLogo()}" alt="dropdown">
                                <!-- /ko -->

                                <!-- ko if: $data.iconUrl && !$data.cssClasses -->
                                    <img data-bind="attr: {src: $data.iconUrl}" alt="dropdown">
                                <!-- /ko -->
                                
                                <!-- ko if: $data.cssClasses && !$data.iconUrl -->
                                    <label  class="bsa-label full-icon" data-bind="css: $data.cssClasses ? $data.cssClasses : ''"></label>
                                <!-- /ko -->

                                <input type="radio" name="multiLevelSelector" data-bind="value: id, checked: $parent.selectedOption, attr:{id: id}, event: { change: $parent.onOptionChange}">

                                <span data-bind="text: name"></span>
                            </label>

                            <!-- ko if: $data.subGroups -->

                                <ul class="bsa-list-second">

                                    <!-- ko foreach: subGroups -->

                                        <li>

                                            <label class="bsa-label full-icon">

                                                <!-- ko if: $parents[1].hasLogo() && $data.iconUrl != null -->
                                                    <img data-bind="attr: {src: $data.iconUrl}" alt="dropdown">
                                                <!-- /ko -->

                                                <!-- ko if: $parents[1].hasLogo() && $data.iconUrl == null && $parents[1].isDefaultLogoDefined() -->
                                                    <img data-bind="attr: {src: $parents[1].defaultLogo()}" alt="dropdown">
                                                <!-- /ko -->

                                                <input type="radio" name="multiLevelSelector" data-bind="value: id, checked: $parents[1].selectedOption, attr:{id: id}, event: { change: $parents[1].onOptionChange}">

                                                <span data-bind="text: name"></span>

                                            </label>

                                        </li>

                                    <!-- /ko -->

                                </ul>

                            <!-- /ko -->

                        </li>

                    <!-- /ko -->

                </ul>
        </div>

            `;
    }

    protected getTemplateName(): string{

        return "filterSingleMultiLevelSelector-template";
    }

    protected buildViewModel(): any{

        // define the viewmodel data/ functions
        let huit_neuf_this = this;

        window.addEventListener('click', event => {
            const filter = document.getElementById(this.idElement);

            if(!filter?.contains(event.target as Element)){
                this.getTemplateViewModel().isVisible(false);
            }
        })

        return  {
            includeAllOptions: ko.observable(false),
            isVisible: ko.observable(false),
            allOptionsText: ko.observable("all"),
            groups: ko.observableArray([]),
            selectedOption: ko.observable(0),
            selectedOptionText: ko.observable(""),
            elementIdentifier: ko.observable(this.idElement),
            label: ko.observable(""),
            hasLogo: ko.observable(false),
            isCssLogo: ko.observable(false),
            defaultLogo: ko.observable(""),
            onOptionChange : function (data) { huit_neuf_this.onOptionChange(data);return true;},
            onMouseOver : function () { huit_neuf_this.onMouseOver();return true;},
            onMouseOut : function () { huit_neuf_this.onMouseOut();return true;},
            onToggleOpen: function () { huit_neuf_this.onToggleOpen();return true; },
            getSelectedOptionLogo: function () {return huit_neuf_this.getSelectedOptionLogo();},
            isDefaultLogoDefined: function () {return huit_neuf_this.isDefaultLogoDefined();}
        };
    }

    public isDefaultLogoDefined(){

        let defaultLogo = this.getTemplateViewModel().defaultLogo();
        
        if (defaultLogo && defaultLogo != "") {

            return true;
        } else {

            return false;
        }
    }

    public getSelectedOptionLogo(){

        const selectedOption = this.getTemplateViewModel().selectedOption();

        if(selectedOption == "all") return null;

        const groups = this.getTemplateViewModel().groups();

        for(let i = 0; i < groups.length; i++){

            if (groups[i].id == selectedOption && groups[i].cssClasses) {

                this.getTemplateViewModel().isCssLogo(true);
                return groups[i].cssClasses;
            } else if(groups[i].id == selectedOption && groups[i].iconUrl){

                this.getTemplateViewModel().isCssLogo(false);
                return groups[i].iconUrl;
            }

            const subGroups = groups[i].subGroups;
            if(!subGroups) continue;

            for(let j = 0; j < subGroups.length; j++){

                if(subGroups[j].id == selectedOption){

                    this.getTemplateViewModel().isCssLogo(false);
                    return subGroups[j].iconUrl;
                }
            }
        }

        this.getTemplateViewModel().isCssLogo(false);
        return null;
    }

    public onToggleOpen() {
        this.getTemplateViewModel().isVisible(!this.getTemplateViewModel().isVisible());
    }

    public setGroups(groups : Array<{id: any, name: string, type: string, cssClasses: string, subGroups?: Array<{id: any, name: string, type: string, cssClasses: string}>}>) {

        let includeAllOption = this.getTemplateViewModel().includeAllOptions();

        for (let group of groups){

            if (group.type) {

                group.id = group.type + "_" + group.id;
            }

            if(group.subGroups){

                for(let subGroup of group.subGroups){

                    if (subGroup.type) {

                        subGroup.id = subGroup.type + "_" + subGroup.id;
                    }
                }
            }
        }

        if (includeAllOption) {

            let allOptionsText = this.getTemplateViewModel().allOptionsText();

            groups.unshift({"id" : "all", "name" : allOptionsText, "type" : "all", "cssClasses": "bsa-all"});

        }

        this.setSelectedOption(groups[0].id);
        this.setSelectedOptionText(groups[0].name);

        this.getTemplateViewModel().groups(groups);
    }

    public setLabel(label : string) {

        this.getTemplateViewModel().label(label);
    }

    public setHasLogo(bool: boolean) {

        this.getTemplateViewModel().hasLogo(bool);
    }

    public setDefaultLogo(path: string){

        this.getTemplateViewModel().defaultLogo(path);
    }

    public setSelectedOption(selectedOption : any) {

        this.getTemplateViewModel().selectedOption(selectedOption);
    }

    public getSelectedOption() {

        return this.getTemplateViewModel().selectedOption();
    }

    public setSelectedOptionText(selectedText : any) {

        this.getTemplateViewModel().selectedOptionText(selectedText);
    }

    public getSelectedOptionText() {

        return this.getTemplateViewModel().selectedOptionText();
    }

    protected onOptionChange(item){

        this.setSelectedOptionText(item.name);
        this.getTemplateViewModel().isVisible(false);
        this.applyFilter();
    }

    protected onMouseOver(){

        this.getTemplateViewModel().isVisible(true);
    }

    protected onMouseOut(){

        this.getTemplateViewModel().isVisible(false);
    }

    public setAllOptionsText(allOptionsText : string) {

        this.getTemplateViewModel().allOptionsText(allOptionsText);
    }

    public setIncludeAllOptions(includeAllOptions : boolean) {

        this.getTemplateViewModel().includeAllOptions(includeAllOptions);
    }


    private applyFilter(){

        this.caller.filterSingleGroupSelectorOnChange(this.idElement);
    }
}



// WEBPACK FOOTER //
// ./vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSingle_multiLevel_selector_template.ts